var map = {
	"./angle-down.svg": 17,
	"./angle-left.svg": 28,
	"./angle-right-grey.svg": 10,
	"./angle-right.svg": 29,
	"./angle-up.svg": 186,
	"./box-package-icon.png": 187,
	"./cart-line-icon.png": 27,
	"./check-mark-circle-line-icon.png": 188,
	"./new-icon.png": 189,
	"./quality-badge-thumbs-up-icon.png": 190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 185;